/* jshint esversion: 6 */
/* jshint ignore:start */
import Logo from "./Images/logoonly.png";
const Loading = () => {
    return (
        <div className="loading">
            <div className="loadercontainer">
                <span className="loader"></span>
                <img className="centerlogo" src={Logo} alt='Logo' />
            </div>
        </div>
    )
}

export default Loading
/* jshint ignore:end */